import React from 'react';
import { Check } from 'lucide-react';

interface BaseTestCardTagItemProps {
    label: string;
}

function BaseTestCardTagItem({ label }: BaseTestCardTagItemProps) {
    return (
        <div className="text-foreground flex flex-row items-center gap-1.5">
            <Check className="text-percentile-top size-4 shrink-0" aria-hidden />
            <span className="text-xs leading-snug font-medium">{label}</span>
        </div>
    );
}

export default BaseTestCardTagItem;
